// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextAreaFormik_wrapper__1DZa4","textArea":"TextAreaFormik_textArea__2lOE6","textArea_error":"TextAreaFormik_textArea_error__3qhz_","error":"TextAreaFormik_error__1aVG2"};